import About from "./components/About";
import Company from "./components/Company";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Portfolio from "./components/Portfolio";
import Project from "./components/Project";
import Homeserver from "./components/Homeserver";
import Experience from "./components/Experience";

function App() {
  return (
    <>
      <Navbar />

      <main className="overflow-x-hidden flex flex-col justify-center">
        <Hero />
        <About />
        <Experience />
        <Portfolio />
        <Project />
        <Homeserver />
        <Company />
        <Contact />
      </main>

      <Footer />
    </>
  );
}

export default App;
